import { formatDate } from './formatDate';
import { formatPercentage } from './numberUtils';

export function formatBondPrice(value?: number | string | null): string {
    return formatPercentage(value, { decimalPlaces: 2 });
}

export function formatBondDate(value?: string | number | Date | null): string {
    return formatDate(value ?? undefined, { withTimeZone: false });
}

export function getRatingColorVariant(rating?: string): 'success' | 'secondary' | 'destructive' | 'outline' {
    if (!rating) return 'outline';
    const upperRating = rating.toUpperCase();

    switch (upperRating[0]) {
        case 'A':
            if (upperRating.startsWith('AAA') || upperRating.startsWith('AA')) {
                return 'success';
            }
            return 'secondary';
        case 'B':
            return upperRating.startsWith('BBB') ? 'secondary' : 'destructive';
        default:
            return 'destructive';
    }
}
